import { createContext, useContext, useState } from "react";

const StaffingSearchContext = createContext();

export const StaffingSearchProvider = ({ children }) => {
  const [searchFilters, setSearchFilters] = useState([]);

  return (
    <StaffingSearchContext.Provider value={{ searchFilters, setSearchFilters }}>
      {children}
    </StaffingSearchContext.Provider>
  );
};

export const useStaffingSearchContext = () => useContext(StaffingSearchContext);
